import React from 'react'
import styled from 'styled-components'

import { Button } from '@sketch/components'
import { ReactComponent as Apple } from '@sketch/icons/img-apple-17'

export const AppleIcon = styled(Apple)`
  width: 17px;
  height: 17px;
  margin-right: 4px;
`

export const StyledButton = styled(Button)`
  flex: 1;
`

interface ContinueWithAppleProps {
  showIconOnly?: boolean
  onClick: () => void
  loading?: boolean
  className?: string
}

export const ContinueWithApple = ({
  showIconOnly = false,
  onClick,
  loading = false,
  className,
}: ContinueWithAppleProps) => {
  return (
    <StyledButton
      className={className}
      variant="primary-untinted"
      size="40"
      fill
      onClick={onClick}
      loading={loading}
    >
      <AppleIcon data-testid="apple-logo" />{' '}
      {!showIconOnly && 'Continue with Apple'}
    </StyledButton>
  )
}
